export { default } from './FadeIn';
